export const FOOTER_PART_1 = 'Software PalmApp Tech s.r.o.';
export const FOOTER_PART_2 = <>&copy; 2021 - {new Date().getFullYear()}</>;

export const EXPORT_LIMIT = 32000;
